import TaskExampleImage from "components/ExampleImage/TaskExampleImage";
import { Flex } from "@chakra-ui/react";
import { useEffect } from "react";
import {
  TemplateTaskActionButton,
  PrebuiltTemplateTaskActionButton,
  PrebuitTaskTemplateActionButtonParentProps,
  TaskTemplateActionButtonParentProps,
  TemplateTaskActionCloseButton,
} from "./TemplateTaskActionButton";
import TemplateActionText from "../TemplateActionText";

export default function TemplateInputEmailTaskAction({ autoOpen, setAutoOpen, onRemove }: TaskTemplateActionButtonParentProps) {
  useEffect(() => {
    if (autoOpen) {
      setAutoOpen(false);
    }
  }, [autoOpen, setAutoOpen]);
  return (
    <TemplateTaskActionButton autoOpen={autoOpen} onRemove={onRemove} buttonText="Email Input" buttonTitle="Email Input">
      <Flex direction="column" pb="4" gap="6" w="100%">
        <TemplateActionText text="Enter a Work Email" />
        <TaskExampleImage taskType="create_email_account" />
      </Flex>
      <TemplateTaskActionCloseButton />
    </TemplateTaskActionButton>
  );
}

export function PrebuiltTemplateInputEmailTaskAction({ prebuiltTaskTemplate }: PrebuitTaskTemplateActionButtonParentProps) {
  return (
    <PrebuiltTemplateTaskActionButton buttonText="Email Input" buttonTitle="Email Input">
      <Flex direction="column" pb="4" gap="6" w="100%">
        <TemplateActionText text="Enter a Work Email" />
        <TaskExampleImage taskType="create_email_account" />
      </Flex>
    </PrebuiltTemplateTaskActionButton>
  );
}
